<div class="container">
  <div class="messenger-box">
    <div>
      <label for="facebook-id" class="input-label">Nhập Zalo OAID tại đây:</label>
      <!-- OAID -->
      <input id="facebook-id" class="input-field" placeholder="Nhập Zalo OAID"
        [(ngModel)]="data.staticdata.zaloFollowAttributes.data_oaid" />
      <button mat-raised-button color="primary" class="btn-update"
        (click)="updateOrAdd({staticdata: data.staticdata})">Cập nhật</button>
    </div>
    <p>
      Hướng dẫn cách lấy OA ID của Zalo doanh nghiệp tại
      <span (click)="showModal()" class="guide">đây</span>
    </p>
  </div>
  <nz-modal [(nzVisible)]="isVisible"
    [nzStyle]="{ maxHeight: '80vh', top: '32px', overflowY : 'scroll', 'paddingBottom': '0' }" [nzWidth]="'70%'"
    (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
    <ng-container *nzModalContent>
      <img src="/assets/root/images/system/imgs/cach_lay_oaid.jpg" style="width: auto; height: auto" />
    </ng-container>
  </nz-modal>
  <!-- Hiển thị số lượng bài viết của zalo, min 1, max 5 -->
  <div class="messenger-box">
    <label class="input-label">Số lượng bài viết hiển thị:</label> <br>
    <nz-input-number [(ngModel)]="data.staticdata?.zaloFollowAttributes.data_article"
      (nzBlur)="updateOrAdd({staticdata: data.staticdata});" [nzMin]="1" [nzMax]="5" [nzStep]="1"></nz-input-number>
  </div>
  <!-- Hiển thị ảnh bìa của zalo, có/không -->
  <div class="messenger-box">
    <label class="input-label">Hiện ảnh bìa bảng tin:</label> <br>
    <nz-radio-group [(ngModel)]="data.staticdata?.zaloFollowAttributes.data_cover"
      (ngModelChange)="updateOrAdd({staticdata: data.staticdata});">
      <label nz-radio nzValue="yes">Có</label>
      <label nz-radio nzValue="no">Không</label>
    </nz-radio-group>
  </div>
</div>